import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { 
  FaLaptopCode, 
  FaCloud, 
  FaRobot, 
  FaShieldAlt,
  FaBrain,
  FaGlobe, 
  FaChartLine, 
  FaMobileAlt,
  FaHospital,
  FaShoppingCart,
  FaGraduationCap,
  FaIndustry,
  FaSpa,
  FaLeaf,
  FaHotel,
  FaBox,
  FaRocket,
  FaStar,
  FaLightbulb,
  FaHandshake,
  FaUsers,
  FaCog,
  FaCheckCircle
} from 'react-icons/fa';
import './services.css';



import { AnimatePresence } from "framer-motion";
import { db } from "../FirebaseComp/firebase"; // adjust path to your firebase.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";









// Reusable animated component
function AnimatedSection({ children, className }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10% 0px" });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7 }}
    >
      {children}
    </motion.div>
  );
}

function Services() {
  const [activeService, setActiveService] = useState(0);

  // Industries data for Sri Lankan market
  const industries = [
    { name: "Healthcare", icon: <FaHospital />, description: "Hospitals, clinics, and healthcare providers" },
    { name: "Retail & E-commerce", icon: <FaShoppingCart />, description: "Retail stores, supermarkets, and online shopping platforms" },
    { name: "Education", icon: <FaGraduationCap />, description: "Schools, universities, and educational institutions" },
    { name: "Manufacturing", icon: <FaIndustry />, description: "Garment, ceramic, and various manufacturing industries" },
    { name: "Beauty Salon & Wellness", icon: <FaSpa />, description: "Spas, beauty parlors, and wellness centers" },
    { name: "Agriculture & Plantations", icon: <FaLeaf />, description: "Tea, rubber, coconut, and other agricultural sectors" },
    { name: "Tourism & Hospitality", icon: <FaHotel />, description: "Hotels, travel agencies, and tourism services" },
    { name: "Export & Trade", icon: <FaBox />, description: "Export companies and international trade businesses" }
  ];

 // Services data
const services = [
  {
    id: 1,
    title: "Web Development",
    icon: <FaGlobe />,
    description:
      "Modern, responsive, and high-performance websites built to showcase your brand and engage your audience.",
    features: [
      "Responsive Website Design",
      "E-commerce Solutions",
      "Content Management Systems",
      "Progressive Web Apps",
      "SEO Optimization"
    ],
    benefits: [
      "Stronger online presence",
      "Improved customer engagement",
      "Optimized for all devices",
      "Better search engine rankings"
    ]
  },
  {
    id: 2,
    title: "Custom Software Development",
    icon: <FaLaptopCode />,
    description:
      "Tailor-made software solutions designed to meet unique business needs and streamline operations.",
    features: [
      "Web Application Development",
      "Desktop Applications",
      "API Development & Integration",
      "Legacy System Modernization",
      "Quality Assurance & Testing"
    ],
    benefits: [
      "Increased operational efficiency",
      "Scalable and future-ready",
      "Seamless system integration",
      "Competitive business advantage"
    ]
  },
  {
    id: 3,
    title: "Mobile App Development",
    icon: <FaMobileAlt />,
    description:
      "Native and cross-platform mobile apps that deliver outstanding user experiences on iOS and Android.",
    features: [
      "iOS & Android Apps",
      "Cross-Platform Development",
      "UI/UX Design",
      "App Store Optimization",
      "App Maintenance & Support"
    ],
    benefits: [
      "Enhanced customer engagement",
      "Expand your digital reach",
      "New revenue opportunities",
      "Strong mobile brand presence"
    ]
  },
  {
    id: 4,
    title: "Digital Transformation",
    icon: <FaCloud />,
    description:
      "Helping businesses embrace digital technologies to innovate, grow, and stay competitive.",
    features: [
      "Business Process Automation",
      "Cloud Solutions & Migration",
      "Enterprise Solutions",
      "Data Analytics & Insights",
      "Workflow Optimization"
    ],
    benefits: [
      "Operational efficiency",
      "Scalable infrastructure",
      "Improved customer experience",
      "Agility in adapting to change"
    ]
  },
  {
    id: 5,
    title: "IT Consulting",
    icon: <FaChartLine />,
    description:
      "Expert advisory services to align technology with your business goals and maximize ROI.",
    features: [
      "Technology Strategy Development",
      "IT Infrastructure Optimization",
      "Process Improvement",
      "Vendor & Risk Management",
      "Future-Ready Roadmaps"
    ],
    benefits: [
      "Informed decision-making",
      "Reduced IT costs",
      "Future-proof strategies",
      "Alignment with business vision"
    ]
  },
  {
    id: 6,
    title: "AI & Machine Learning",
    icon: <FaBrain />,
    description:
      "Intelligent solutions that leverage AI to automate processes, analyze data, and drive innovation.",
    features: [
      "Predictive Analytics",
      "Natural Language Processing",
      "Computer Vision",
      "Recommendation Systems",
      "AI Strategy & Integration"
    ],
    benefits: [
      "Smarter business insights",
      "Process automation",
      "Enhanced customer experiences",
      "Competitive advantage"
    ]
  }
];

  const processSteps = [
    {
      step: "01",
      title: "Discovery & Analysis",
      description: "We begin by thoroughly understanding your business objectives, challenges, and requirements."
    },
    {
      step: "02",
      title: "Planning & Strategy",
      description: "Our experts develop a comprehensive strategy tailored to your specific needs and goals."
    },
    {
      step: "03",
      title: "Design & Development",
      description: "We create innovative solutions using cutting-edge technologies and best practices."
    },
    {
      step: "04",
      title: "Testing & Quality Assurance",
      description: "Rigorous testing ensures your solution meets the highest standards of quality and performance."
    },
    {
      step: "05",
      title: "Deployment & Launch",
      description: "We seamlessly implement your solution with minimal disruption to your operations."
    },
    {
      step: "06",
      title: "Support & Maintenance",
      description: "Ongoing support and optimization to ensure your solution continues to deliver value."
    }
  ];
















  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    projectTitle: "",
    projectDetails: "",
    budget: "",
    timeline: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "startyourproject"), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      alert("Thank you! We’ll contact you soon.");
      setFormData({
        name: "",
        email: "",
        company: "",
        projectTitle: "",
        projectDetails: "",
        budget: "",
        timeline: "",
      });
      setIsOpen(false);
    } catch (error) {
      console.error("Error saving project:", error);
      alert("Something went wrong, please try again.");
    }
  };










  return (
    <div className="services-container">
      {/* ===== HERO SECTION ===== */}
      <section className="services-hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <motion.div 
          className="services-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-badge">
            <span>Expert Solutions</span>
          </div>
          <h1>Comprehensive <span className="gradient-text">IT Services</span></h1>
          <p className="hero-subtitle">
            Leverage our expertise to transform your business with cutting edge technology solutions 
            designed for innovation, scalability, and sustainable growth.
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">14+</span>
              <span className="stat-label">Technologies</span>
            </div>
            <div className="stat">
              <span className="stat-number">4+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat">
              <span className="stat-number">99%</span>
              <span className="stat-label">Client Retention</span>
            </div>
          </div>
        </motion.div>
      </section>

      {/* ===== SERVICES GRID ===== */}
      <AnimatedSection className="services-grid-section">
        <div className="section-header">
          <h2>Our Core Services</h2>
          <p>Comprehensive IT solutions tailored to drive your business forward</p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className={`service-card ${activeService === index ? 'active' : ''}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              onClick={() => setActiveService(index)}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="service-features">
                {service.features.slice(0, 3).map((feature, i) => (
                  <span key={i} className="feature-tag">{feature}</span>
                ))}
                {service.features.length > 3 && (
                  <span className="feature-tag">+{service.features.length - 3} more</span>
                )}
              </div>
              {/* <button className="service-cta">Learn More →</button> */}
            </motion.div>
          ))}
        </div>
      </AnimatedSection>



      {/* ===== SERVICE DETAIL SECTION ===== */}
      <AnimatedSection className="service-detail-section">
        <div className="detail-container">
          <div className="detail-content">
            <h2>{services[activeService].title}</h2>
            <p>{services[activeService].description}</p>
            
            <div className="features-list">
              <h4>Key Features</h4>
              <ul>
                {services[activeService].features.map((feature, index) => (
                  <li key={index}><FaCheckCircle className="feature-check" /> {feature}</li>
                ))}
              </ul>
            </div>
            
            <div className="benefits-list">
              <h4>Business Benefits</h4>
              <ul>
                {services[activeService].benefits.map((benefit, index) => (
                  <li key={index}><FaCheckCircle className="benefit-check" /> {benefit}</li>
                ))}
              </ul>
            </div>
            
          <motion.a
            href="mailto:info@glaxmore.com"
            className="btn btn-primary inline-block"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Request Consultation
          </motion.a>

          </div>
          
          <div className="detail-visual">
            <div className="visual-placeholder">
              <div className="rotating-ring"></div>
              <div className="floating-elements">
                <div className="element element-1">{services[activeService].icon}</div>
                <div className="element element-2"><FaRocket /></div>
                <div className="element element-3"><FaStar /></div>
              </div>
              <div className="main-circle">
                <span>Innovation</span>
              </div>
            </div>
          </div>
        </div>
      </AnimatedSection>

      {/* ===== INDUSTRIES SECTION ===== */}
      <AnimatedSection className="industries-section">
        <div className="section-header">
          <h2>Industries We Serve in Sri Lanka</h2>
          <p>Tailored solutions for diverse industry challenges and opportunities</p>
        </div>
        
        <div className="industries-grid">
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              className="industry-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className="industry-icon">{industry.icon}</div>
              <h4>{industry.name}</h4>
              <p>{industry.description}</p>
            </motion.div>
          ))}
        </div>
      </AnimatedSection>

      {/* ===== PROCESS SECTION ===== */}
      <AnimatedSection className="process-section">
        <div className="section-header">
          <h2>Our Process</h2>
          <p>A structured approach to delivering exceptional results</p>
        </div>
        
        <div className="process-steps">
          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              className="process-step"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.7, delay: index * 0.2 }}
            >
              <div className="step-number">{step.step}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </AnimatedSection>

    <>
      {/* ===== CTA SECTION ===== */}
      <section className="services-cta">
        <div className="services-cta-mesh"></div>
        <div className="services-cta-orb orb-1"></div>
        <div className="services-cta-orb orb-2"></div>
        <div className="services-cta-orb orb-3"></div>

        <motion.div 
          className="services-cta-glass-panel"
          whileHover={{ 
            rotateX: -2, 
            rotateY: 2, 
            scale: 1.01 
          }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
        >
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>Schedule a free consultation with our experts to discuss your project requirements</p>
            <div className="cta-buttons">
              <motion.button
                className="start-btn"
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 10px 25px rgba(37, 99, 235, 0.3)",
                }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsOpen(true)}
              >
                Start Your Project
              </motion.button>
            </div>
          </div>
        </motion.div>
      </section>
      

      {/* Modal - Placed at the root level of the component */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          >
            <motion.div
              className="modal-box"
              initial={{ scale: 0.8, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 50 }}
              transition={{ type: "spring", stiffness: 100, damping: 15 }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="modal-close"
              >
                ×
              </button>

              <h2>Tell Us About Your Project</h2>

              <form onSubmit={handleSubmit} className="form-grid">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="projectTitle"
                  placeholder="Project Title"
                  value={formData.projectTitle}
                  onChange={handleChange}
                  required
                />
                <textarea
                  name="projectDetails"
                  placeholder="Project Details"
                  rows="3"
                  value={formData.projectDetails}
                  onChange={handleChange}
                  required
                ></textarea>
                <input
                  type="text"
                  name="budget"
                  placeholder="Estimated Budget (LKR / USD)"
                  value={formData.budget}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="timeline"
                  placeholder="Expected Timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                />

                <motion.button
                  type="submit"
                  className="submit-btn"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Submit Project
                </motion.button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>



    </div>
  );
}

export default Services;